// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LPHHh","fullView":"styles_fullView__2j8eu"};